const $scrollToNode = $('#scrollTop');

$scrollToNode.on('click', function() {
  window.scroll({
    top: 0,
    behavior: 'smooth'
  });
  return false;
});
